module.exports = __webpack_public_path__ + "static/media/searchLight.befbbd53.svg";